const MIRRORS_SW_FILENAME = 'mirrors5_2.js';

const OLD_MIRRORS_SW_FILENAME = ['spoofer+offline.js', 'mirrors.js', 'mirrors1.js', 'mirrors2.js'];

export function handleMirrorsSwRegistration(isEnabled: boolean) {
  if (isEnabled) return registerMirrorsServiceWorker();
  return unregisterMirrorsServiceWorker();
}

function registerMirrorsServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
      navigator.serviceWorker
        .register(`/${MIRRORS_SW_FILENAME}`, {
          scope: '/'
        })
        .then((registration) => {
          console.log('Service Worker registered with scope: ', registration.scope);
        })
        .catch((error) => {
          console.log('Service Worker registration failed: ', error);
        });
    });
  }
}

export function unregisterMirrorsServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (const registration of registrations) {
        if (
          registration.active?.scriptURL &&
          OLD_MIRRORS_SW_FILENAME.some((value) => registration.active?.scriptURL.includes(value))
        ) {
          registration.unregister();
        }
      }
    });
  }
}
